import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { getLogoFromPartner } from '../../shared-components/icons';
import { mapLogosNames } from './customer-table-utils';
import { Recipient, Share } from '@algoan/dashboard/model';
import styled from 'styled-components';

interface LogoTooltipMessageProps {
  shares: Share[];
  recipients: Recipient[] | undefined;
}

export const LogoTooltipMessage: React.FC<LogoTooltipMessageProps> = ({ shares, recipients }) => {
  const partnerNames = mapLogosNames(shares, recipients);
  const numOfNames = partnerNames.length;
  const lastElementIndex = numOfNames - 1;

  return (
    <S.Container>
      <FormattedMessage
        id="tooltip_partner.message"
        defaultMessage="The file has been sent to{partners}."
        description="Title of the tooltip"
        values={{
          partners: partnerNames.map((partnerName, index) => {
            return (
              <Fragment key={partnerName.name + index}>
                {index > 0 && index !== lastElementIndex && ','}
                {index > 0 && index === lastElementIndex && (
                  <>
                    &nbsp;
                    <FormattedMessage
                      id="tooltip_partner.conjunction"
                      defaultMessage="and"
                      description="Conjunction between partner names"
                    />
                  </>
                )}
                <S.LogoName>
                  <S.Logo alt={partnerName.name} src={getLogoFromPartner(partnerName.name)} />
                  &nbsp;
                  {partnerName.name}
                </S.LogoName>
              </Fragment>
            );
          }),
        }}
      />
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    display: flex;
    flex-wrap: wrap;
  `,
  LogoName: styled.div`
    align-items: center;
    display: inline-flex;
    flex-direction: row;
    margin-left: 6px;
  `,
  Logo: styled.img`
    max-height: 16px;
    width: 16px;
  `,
};
